 export const onElementInView = (element, callback) => {
  let observer

  if (typeof IntersectionObserver !== "undefined") {
    observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) callback();
    }, { root: document.body, threshold: [0.2] });

    observer.observe(element)
  } else {
    callback()
  }

  return {
    unobserve() {
      if (!observer) return

      observer.unobserve(element)
    }
  }
}
